export default {
  YourPassword: 'Votre mot de passe a été modifié.',
  CanBeUsed: 'Vous pouvez l\'utiliser pour vous connecter dès maintenant.',
  CloseWindow: 'Veuillez fermer cette fenêtre et vous connecter à nouveau.',
  Connect: 'Me connecter',
  notFound: 'Non trouvé',
};
